import type { TechniqueEntry } from '../schema';

// review: candidate draft — name-only today (no shipped delivery prose); needs genuine clinical
// origination review, not just sign-off.
export const sleepAndCravings: TechniqueEntry = {
  key: 'sleep_and_cravings',
  version: '0.2-candidate',
  name: 'Sleep and cravings',
  pillar: 'CBT',
  serves:
    "Connecting the member's sleep to their craving pattern (poor nights priming harder days) from whatever sleep picture is available: their daily tracking, the welcome series, or what they have just shared.",
  method: [
    "Start from their own sleep account, wherever it surfaced: their daily tracking, the welcome walk-through's sleep touchpoint, or what they have told you in this conversation.",
    'Lay the two rhythms side by side in their instances: the nights sleep breaks, and the days the pull is loudest.',
    "Offer the link once, in plain words (drinking breaks up the night's sleep even when it helps them drop off, and a short night makes the next day's pull louder) and let them test it against their own week rather than asserting it holds for them.",
    'Close on the one lever they own (the wind-down, the timing, the nightcap belief if it is theirs), named, not planned.',
  ],
  never: [
    'No sleep-hygiene lecture.',
    'No medical territory: apnea, medication, dosing belong to their doctor.',
    'Never assert their pattern shows the link if their data does not.',
  ],
  requiresFirst: [
    {
      // review: the on-record branch names daily tracking and welcome-series records, which are not
      // other techniques' builds (no structured source exists for them yet), and the clause's
      // in-conversation branch means a fail-closed on_record gate would wrongly refuse members
      // who brought the evidence themselves — so this stays conversation-shaped.
      kind: 'conversation',
      clause:
        'A sleep picture to work from: on record (daily tracking, welcome series) or given in this conversation in their own words.',
    },
  ],
  doneWhen:
    'The member connects a named bad night to a named hard day themselves, and one lever is theirs.',
  firstMove: null,
  exemplars: [],
  appliesTo: ['base', 'journey'],
  programs: null,
  signature: null,
  source:
    'Intake preview naming; catalog A7 rationale (sleep architecture); welcome_objective.md sleep touchpoint (one of the data sources). Name-only today.',
};
